/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import FirstLine from './FirstLine/index'
import ProfilePicture from './ProfilePicture/index'
import React from 'react'
import SecondLine from './SecondLine/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/ReferralSource/Content/Content/Referrals/Referral/Source/Search/SearchBar/Content/Content/Option"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
  return (<React.Fragment
>
<button
  data-testid="Option.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-6-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-7-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-8-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-10-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-Z2h7tiu': isHovered ? dtColorsNeutral200 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfilePicture
  viewPath={`${viewPath}/ProfilePicture`}
/>
<div
  data-testid="Option.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<FirstLine
  viewPath={`${viewPath}/FirstLine`}
/>
<SecondLine
  viewPath={`${viewPath}/SecondLine`}
/>
</div>
</button>
{children}
</React.Fragment>)
}